import VueQrcode from '@xkeshi/vue-qrcode'
export default {
  name: 'qr-code',
  components: {'qrcode': VueQrcode},
  props: [],
  data () {
    return {
      qr_code: {
        'URL_API': process.env.URL_API,
        // 'URL_API': '"http://localhost:8000/api/v3.0/"',
        'APP_NAME': 'Petrolimex Aviation',
        'URL_SOCKET': process.env.URL_SOCKET
      }
    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {

  }
}



// WEBPACK FOOTER //
// ./src/components/qr-code/qr-code.js